/**
 * Desktop toast stack (INVENTORY-DESKTOP §4 row 8; prototype line 1150).
 *
 * Same store slice as mobile (`slices/toasts.ts` owns the 2600ms dismiss and
 * pre-resolves `bd` to the right accent), different geometry — which is the
 * only reason this is not `components/ToastHost.tsx`:
 *
 *   mobile   `bottom:90px` (clears the 82px bottom nav), `max-width:402px`,
 *            `padding:10px 14px`, mono 10.5px, side padding for the 430px column
 *   desktop  `bottom:22px` (there is no bottom nav), no width cap,
 *            `padding:10px 16px`, mono 11px
 *
 * Both are `position:fixed; left:50%; translateX(-50%); z-index:100;
 * pointer-events:none; animation:gt-toast .18s ease-out`. Exactly one of the
 * two is mounted at a time — `App.tsx` renders one tree or the other.
 *
 * Fire a toast from anywhere with `useQd.getState().toast('…')`.
 */

import { useQd } from '../../store/index.ts';

export function DesktopToastHost(): JSX.Element {
  const toasts = useQd((s) => s.toasts);
  return (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: '22px',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        alignItems: 'center',
        pointerEvents: 'none',
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            background: 'var(--gt-card)',
            border: '1px solid ' + t.bd,
            boxShadow: 'var(--gt-shadow-toast)',
            padding: '10px 16px',
            fontFamily: 'var(--gt-font-mono)',
            fontSize: '11px',
            color: 'var(--gt-text)',
            animation: 'gt-toast .18s ease-out',
            textAlign: 'center',
          }}
        >
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
}

export default DesktopToastHost;
